/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CurrencyAmount } from './CurrencyAmount';
import {
    CurrencyAmountFromJSON,
    CurrencyAmountFromJSONTyped,
    CurrencyAmountToJSON,
    CurrencyAmountToJSONTyped,
} from './CurrencyAmount';

/**
 * A rate alert for tracking hotel prices
 * @export
 * @interface RateAlert
 */
export interface RateAlert {
    /**
     * Alert ID
     * @type {number}
     * @memberof RateAlert
     */
    id?: number;
    /**
     * User ID who created the alert
     * @type {string}
     * @memberof RateAlert
     */
    userId: string;
    /**
     * The vervotech property ID being tracked
     * @type {number}
     * @memberof RateAlert
     */
    vervotechPropertyId: number;
    /**
     * The name of the hotel from property content
     * @type {string}
     * @memberof RateAlert
     */
    hotelName?: string;
    /**
     * URL of the hero image from property content
     * @type {string}
     * @memberof RateAlert
     */
    heroImage?: string;
    /**
     * Supplier ID from property content (null if property not bookable)
     * @type {string}
     * @memberof RateAlert
     */
    supplierId?: string;
    /**
     * Check-in date (null for 'any X night stay')
     * @type {Date}
     * @memberof RateAlert
     */
    checkinDate?: Date;
    /**
     * Check-out date (null for 'any X night stay')
     * @type {Date}
     * @memberof RateAlert
     */
    checkoutDate?: Date;
    /**
     * Number of nights for 'any X night stay' feature
     * @type {number}
     * @memberof RateAlert
     */
    numberOfNights?: number;
    /**
     * 
     * @type {CurrencyAmount}
     * @memberof RateAlert
     */
    currentCash?: CurrencyAmount;
    /**
     * 
     * @type {CurrencyAmount}
     * @memberof RateAlert
     */
    currentPoints?: CurrencyAmount;
    /**
     * When the last email was sent for this alert
     * @type {Date}
     * @memberof RateAlert
     */
    lastEmailSentAt?: Date;
    /**
     * When the alert was created
     * @type {Date}
     * @memberof RateAlert
     */
    createdAt?: Date;
    /**
     * When the alert was last updated
     * @type {Date}
     * @memberof RateAlert
     */
    updatedAt?: Date;
}

/**
 * Check if a given object implements the RateAlert interface.
 */
export function instanceOfRateAlert(value: object): value is RateAlert {
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('vervotechPropertyId' in value) || value['vervotechPropertyId'] === undefined) return false;
    return true;
}

export function RateAlertFromJSON(json: any): RateAlert {
    return RateAlertFromJSONTyped(json, false);
}

export function RateAlertFromJSONTyped(json: any, ignoreDiscriminator: boolean): RateAlert {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'userId': json['user_id'],
        'vervotechPropertyId': json['vervotech_property_id'],
        'hotelName': json['hotel_name'] == null ? undefined : json['hotel_name'],
        'heroImage': json['hero_image'] == null ? undefined : json['hero_image'],
        'supplierId': json['supplier_id'] == null ? undefined : json['supplier_id'],
        'checkinDate': json['checkin_date'] == null ? undefined : (new Date(json['checkin_date'])),
        'checkoutDate': json['checkout_date'] == null ? undefined : (new Date(json['checkout_date'])),
        'numberOfNights': json['number_of_nights'] == null ? undefined : json['number_of_nights'],
        'currentCash': json['current_cash'] == null ? undefined : CurrencyAmountFromJSON(json['current_cash']),
        'currentPoints': json['current_points'] == null ? undefined : CurrencyAmountFromJSON(json['current_points']),
        'lastEmailSentAt': json['last_email_sent_at'] == null ? undefined : (new Date(json['last_email_sent_at'])),
        'createdAt': json['created_at'] == null ? undefined : (new Date(json['created_at'])),
        'updatedAt': json['updated_at'] == null ? undefined : (new Date(json['updated_at'])),
    };
}

export function RateAlertToJSON(json: any): RateAlert {
    return RateAlertToJSONTyped(json, false);
}

export function RateAlertToJSONTyped(value?: RateAlert | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'user_id': value['userId'],
        'vervotech_property_id': value['vervotechPropertyId'],
        'hotel_name': value['hotelName'],
        'hero_image': value['heroImage'],
        'supplier_id': value['supplierId'],
        'checkin_date': value['checkinDate'] == null ? value['checkinDate'] : value['checkinDate'].toISOString().substring(0,10),
        'checkout_date': value['checkoutDate'] == null ? value['checkoutDate'] : value['checkoutDate'].toISOString().substring(0,10),
        'number_of_nights': value['numberOfNights'],
        'current_cash': CurrencyAmountToJSON(value['currentCash']),
        'current_points': CurrencyAmountToJSON(value['currentPoints']),
        'last_email_sent_at': value['lastEmailSentAt'] == null ? value['lastEmailSentAt'] : value['lastEmailSentAt'].toISOString(),
        'created_at': value['createdAt'] == null ? value['createdAt'] : value['createdAt'].toISOString(),
        'updated_at': value['updatedAt'] == null ? value['updatedAt'] : value['updatedAt'].toISOString(),
    };
}

